import React, { PropTypes, Component } from "react";
import styled from "styled-components";
import { NitroIcon } from "nitro-components";
import VehicleImage from "./VehicleImage";

const VehicleAvatarContainer = styled.div`
  position: relative;
  float: left;
  margin-right: 20px;
  border-radius: 100%;
  width: ${props =>props.width? props.width: props.size}px;
  height: ${props => props.height? props.height: props.size}px;
  background: ${props => props.theme.color[props.variant]};
  background: #fff;
  opacity:${props => props.opacity};
  margin-bottom:${props => props.bottom}px;
  padding: ${props => props.padding}px;
  padding-top:  ${props => props.padding + 10}px;
`;

const VehicleAvatar = props => {
	const {
		variant,
    size,
    width,
    height,
		profileIconVariant,
		profileIconSize,
		opacity,
		bottom,
		imageKey,
		horizontal,
		horizontalImgWidthPercentage,
		padding
	} = props;

	return (
		<VehicleAvatarContainer
      width={width}
      height={height}
			size={size}
			variant={variant}
			opacity={opacity}
			bottom={bottom}
			padding={padding}
		>
			<VehicleImage imageKey={imageKey} horizontal={horizontal} horizontalImgWidthPercentage={horizontalImgWidthPercentage} />
		</VehicleAvatarContainer>
	);
};

VehicleAvatar.propTypes = {
	profileIconSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	profileIconVariant: PropTypes.string,
	imageKey: PropTypes.string,
	horizontal: PropTypes.bool,
	horizontalImgWidthPercentage:PropTypes.string,
	variant: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	opacity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	bottom: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	padding: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

VehicleAvatar.defaultProps = {
	size: 80,
	variant: "border",
	profileIconVariant: "white",
	opacity: 1,
	bottom: 0,
	padding: 18
};

export default VehicleAvatar;



// WEBPACK FOOTER //
// ./src/components/vehicle/VehicleAvatar.js